import { cn } from '@/utils/utils';
import React from 'react';

export default function GridBrandCard({ className, ...rest }: { className?: string } & React.ComponentProps<'div'>) {
  return (
    <div
      {...rest}
      className={cn(
        'grid w-full grid-cols-[repeat(auto-fill,minmax(150px,1fr))] gap-4 px-2 py-2 sm:gap-6 md:grid-cols-[repeat(auto-fill,minmax(230px,1fr))]',
        className
      )}
    >
      {rest.children}
    </div>
  );
}
